import YAML, { isMap, isSeq, Document, Node, YAMLMap, YAMLSeq } from 'yaml';

export default function upsertBase(
  courseYaml: string,
  screenYaml: string
): string {
  const doc: Document.Parsed = YAML.parseDocument(courseYaml);
  const screenDoc = YAML.parseDocument(screenYaml.trim());
  const screenNode = screenDoc.contents as Node;

  if (!isMap(screenNode))
    throw new Error('screenYaml must be a YAML mapping (object)');

  const screenObj = YAML.parse(screenYaml.trim()) as {
    id?: string;
    bank?: string | number;
  };
  const screenId = screenObj?.id;
  const screenBank = (screenObj as any)?.bank;
  if (!screenId) throw new Error('screenYaml is missing an id property');

  const pages = doc.get('pages') as YAMLSeq | undefined;
  if (!pages || !isSeq(pages))
    throw new Error('courseYaml is missing top-level pages');

  let replaced = false;

  for (const page of pages.items) {
    if (!isMap(page)) continue;
    const screens = page.get('screens') as YAMLSeq | undefined;
    if (!screens || !isSeq(screens)) continue;

    for (let i = 0; i < screens.items.length; i++) {
      const s = screens.items[i];
      if (!isMap(s)) continue;

      const idNode = s.get('id') as any;
      const bankNode = s.get('bank') as any;
      const idVal = isMap(idNode) ? null : (idNode?.toJSON?.() ?? idNode);
      const bankVal = isMap(bankNode)
        ? null
        : (bankNode?.toJSON?.() ?? bankNode);

      const idMatches = idVal === screenId;
      const bankMatches = screenBank === undefined || bankVal === screenBank;

      if (idMatches && bankMatches) {
        screens.items[i] = screenNode;
        replaced = true;
        break;
      }
    }
    if (replaced) break;
  }

  if (!replaced) throw new Error(`screen id "${screenId}" not found in pages`);
  return doc.toString();
}
